var _rawFetch = window.fetch;

/* ── Shared helpers ─────────────────────────────────────────────────────────
   liEsc       HTML-escape anything that came from a cart line or the builder.
   liIsBrief   True for a line added by the Lovable builder ("Custom quote
               request"). These are $0 quote lines: no units, no price.
   liBriefInfo Display fields for a brief line (title, sub, image).
   liCartError Turns a /cart/*.js response into a real error message, or null
               when it succeeded (status 422, "Cart Error", any 4xx-5xx).
   ──────────────────────────────────────────────────────────────────────── */
function liEsc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function liIsBrief(props) {
  if (!props) return false;
  return props['Order type'] === 'Custom quote request' || !!props['Brief ID'];
}

function liBriefInfo(props) {
  props = props || {};
  var product = props['Product'] || 'Custom';
  var n = parseInt(props['Designs'], 10) || 1;
  var img = props['_preview'] || '';
  if (img && img.indexOf('//') === 0) img = 'https:' + img;
  return {
    title: product + ' design brief',
    sub: n + ' design' + (n !== 1 ? 's' : '') + ', priced after review',
    img: img,
    designs: n,
    // Older briefs carry the bare domain, which has no SSL.
    link: String(props['Design link'] || '').replace(/^https?:\/\/luckyinger\.com\.au/i, 'https://www.luckyinger.com.au'),
    notes: props['Client notes'] || ''
  };
}

function liCartError(status, data) {
  data = data || {};
  var bad = status >= 400 || data.status === 422 ||
    (typeof data.status === 'number' && data.status >= 400) ||
    data.message === 'Cart Error';
  if (!bad) return null;
  return data.description || data.message || ('Cart error (' + status + ')');
}

function liReadCartJson(r) {
  return r.text().then(function (t) {
    var data = {};
    try { data = t ? JSON.parse(t) : {}; } catch (e) { data = { description: t }; }
    var err = liCartError(r.status, data);
    if (err) throw new Error(err);
    return data;
  });
}

/**
 * Lucky Inger: localStorage Order Store
 */

window.LIOrder = (function () {
  var KEY = 'li_order';

  function load() {
    try {
      var raw = localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
      if (!raw) return { items: [] };
      var data = JSON.parse(raw);
      if (!localStorage.getItem(KEY) && sessionStorage.getItem(KEY)) {
        try { localStorage.setItem(KEY, raw); } catch(e) {}
      }
      return data;
    } catch (e) { return { items: [] }; }
  }

  function save(data) {
    try {
      var json = JSON.stringify(data);
      localStorage.setItem(KEY, json);
      sessionStorage.setItem(KEY, json);
      window.dispatchEvent(new CustomEvent('li:order:updated', { detail: data }));
      LIOrder.updateBadge();
    } catch (e) { console.error('LIOrder save error:', e); }
  }

  function uid() {
    return 'li-' + Math.random().toString(36).slice(2, 9) + '-' + Date.now();
  }

  var LIOrder = {
    get: function () { return load(); },
    items: function () { return load().items; },

    totalUnits: function () {
      return load().items.reduce(function (sum, item) {
        return sum + Object.values(item.sizes || {}).reduce(function (s, q) {
          return s + (parseInt(q) || 0);
        }, 0);
      }, 0);
    },

    count: function () { return load().items.length; },

    add: function (item) {
      var data = load();
      item.id = uid();
      item.addedAt = new Date().toISOString();
      data.items.push(item);
      save(data);
      return item.id;
    },

    remove: function (id) {
      var data = load();
      data.items = data.items.filter(function (i) { return i.id !== id; });
      save(data);
    },

    clear: function () {
      localStorage.removeItem(KEY);
      sessionStorage.removeItem(KEY);
      window.dispatchEvent(new CustomEvent('li:order:updated', { detail: { items: [] } }));
      LIOrder.updateBadge();
    },

    updateBadge: function () {
      var liCount = load().items.length;
      _rawFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { LIOrder._applyBadge(liCount + (cart.item_count || 0)); })
        .catch(function () { LIOrder._applyBadge(liCount); });
    },

    _applyBadge: function (count) {
      var cartAnchor = document.getElementById('cart-icon-bubble') ||
                       document.querySelector('a[href="/cart"].header__icon--cart') ||
                       document.querySelector('a[href="/cart"]');
      if (!cartAnchor) return;
      var bubble = cartAnchor.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          cartAnchor.appendChild(bubble);
        }
        var ariaSpan   = bubble.querySelector('span[aria-hidden]');
        var visualSpan = bubble.querySelector('.visually-hidden');
        if (ariaSpan)   ariaSpan.textContent  = count < 100 ? String(count) : '99+';
        if (visualSpan) visualSpan.textContent = count + ' item' + (count !== 1 ? 's' : '');
        bubble.style.display = '';
      } else {
        if (bubble) bubble.style.display = 'none';
      }
    }
  };

  document.addEventListener('DOMContentLoaded', function () { LIOrder.updateBadge(); });

  return LIOrder;
})();


// ── LI Cart Popup Notification ────────────────────────────────────────────────
// One popup for every add: order sections, standard products and the builder.
// Primary action is "Review order" (/cart), never straight to /checkout, so
// the cart page's minimum checks and line sync always run before checkout.

(function () {
  var POPUP_ID = 'li-cart-popup';

  (function () {
    var s = document.createElement('style');
    s.id = 'li-cart-popup-styles';
    s.textContent = [
      '#li-cart-popup {',
      '  position: fixed; top: 80px; right: 16px; z-index: 99999;',
      '  width: 340px; max-width: calc(100vw - 32px);',
      '  background: rgb(var(--color-background, 255 255 255));',
      '  color: rgb(var(--color-foreground, 18 18 18));',
      '  border: 1px solid rgba(var(--color-foreground, 18 18 18), 0.12);',
      '  border-radius: var(--popup-corner-radius, 8px);',
      '  box-shadow: 0 4px 24px rgba(0,0,0,0.13);',
      '  padding: 16px; display: flex; gap: 12px; align-items: flex-start;',
      '  opacity: 0; transform: translateY(-8px);',
      '  transition: opacity 0.22s ease, transform 0.22s ease;',
      '  pointer-events: none;',
      '}',
      'body.li-on-builder #li-cart-popup { top: 56px; }',
      '#li-cart-popup.li-popup--visible { opacity: 1; transform: translateY(0); pointer-events: auto; }',
      '#li-cart-popup .li-popup-img { width: 56px; height: 56px; object-fit: cover; border-radius: 4px; flex-shrink: 0; background: rgba(var(--color-foreground, 18 18 18), 0.06); }',
      '#li-cart-popup .li-popup-img-ph { width: 56px; height: 56px; border-radius: 4px; flex-shrink: 0; background: rgba(var(--color-foreground, 18 18 18), 0.06); }',
      '#li-cart-popup .li-popup-body { flex: 1; min-width: 0; padding-right: 14px; }',
      '#li-cart-popup .li-popup-label { font-size: 11px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; opacity: 0.55; margin-bottom: 4px; }',
      '#li-cart-popup.li-popup--error .li-popup-label { color: #e74c3c; opacity: 1; }',
      '#li-cart-popup .li-popup-title { font-size: 13px; font-weight: 600; margin-bottom: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }',
      '#li-cart-popup .li-popup-sub { font-size: 12px; opacity: 0.65; line-height: 1.4; }',
      '#li-cart-popup .li-popup-actions { display: flex; gap: 8px; margin-top: 10px; }',
      '#li-cart-popup .li-popup-btn { flex: 1; padding: 8px 10px; font-size: 12px; font-weight: 600; text-align: center; border-radius: 4px; cursor: pointer; text-decoration: none; border: 1px solid rgba(var(--color-foreground, 18 18 18), 0.2); background: transparent; color: rgb(var(--color-foreground, 18 18 18)); font-family: inherit; transition: background 0.15s; }',
      '#li-cart-popup .li-popup-btn--primary { background: rgb(var(--color-button, var(--color-foreground, 18 18 18))); color: rgb(var(--color-button-text, var(--color-background, 255 255 255))); border-color: transparent; }',
      '#li-cart-popup .li-popup-close { position: absolute; top: 8px; right: 8px; width: 24px; height: 24px; background: none; border: none; cursor: pointer; opacity: 0.4; font-size: 18px; line-height: 1; padding: 0; display: flex; align-items: center; justify-content: center; color: inherit; }'
    ].join('\n');
    document.head.appendChild(s);
  })();

  function getPopup() {
    var el = document.getElementById(POPUP_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = POPUP_ID;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
      el.addEventListener('mouseenter', function () { clearTimeout(_hideTimer); });
      el.addEventListener('mouseleave', function () {
        if (!el.classList.contains('li-popup--sticky')) _hideTimer = setTimeout(hidePopup, 3000);
      });
      el.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-li-popup-close]') : null;
        if (b) { e.preventDefault(); hidePopup(); }
      });
    }
    return el;
  }

  var _hideTimer = null;

  /* opts: title, sub, imgSrc, label, error, sticky, stayLabel
     stayLabel is the secondary button ("Keep shopping" / "Keep designing"). */
  function showPopup(opts) {
    opts = opts || {};
    var el = getPopup();
    var imgHtml = opts.imgSrc
      ? '<img class="li-popup-img" src="' + liEsc(opts.imgSrc) + '" alt="">'
      : '<div class="li-popup-img-ph"></div>';
    var actions = opts.error
      ? '<button type="button" class="li-popup-btn" data-li-popup-close>Close</button>'
      : '<button type="button" class="li-popup-btn" data-li-popup-close>' + liEsc(opts.stayLabel || 'Keep shopping') + '</button>' +
        '<a href="/cart" target="_top" class="li-popup-btn li-popup-btn--primary">Review order</a>';
    el.innerHTML =
      '<button type="button" class="li-popup-close" aria-label="Close" data-li-popup-close>&times;</button>' +
      imgHtml +
      '<div class="li-popup-body">' +
        '<div class="li-popup-label">' + liEsc(opts.label || (opts.error ? 'Not added' : 'Added to your order')) + '</div>' +
        '<div class="li-popup-title">' + liEsc(opts.title || 'Item added') + '</div>' +
        '<div class="li-popup-sub">' + liEsc(opts.sub || '') + '</div>' +
        '<div class="li-popup-actions">' + actions + '</div>' +
      '</div>';
    el.classList.toggle('li-popup--error', !!opts.error);
    el.classList.toggle('li-popup--sticky', !!(opts.sticky || opts.error));
    el.classList.remove('li-popup--visible');
    void el.offsetWidth;
    el.classList.add('li-popup--visible');
    if (window.LIOrder) window.LIOrder.updateBadge();
    clearTimeout(_hideTimer);
    if (!opts.sticky && !opts.error) _hideTimer = setTimeout(hidePopup, 6000);
  }

  function hidePopup() {
    var el = document.getElementById(POPUP_ID);
    if (el) el.classList.remove('li-popup--visible');
  }

  function onCartPage() { return window.location.pathname === '/cart'; }

  var _lastLICount = 0;
  document.addEventListener('DOMContentLoaded', function () {
    _lastLICount = window.LIOrder ? window.LIOrder.count() : 0;
  });

  window.addEventListener('li:order:updated', function (e) {
    var items = e.detail && e.detail.items ? e.detail.items : [];
    var newCount = items.length;
    if (newCount > _lastLICount && items.length > 0 && !onCartPage()) {
      var last = items[items.length - 1];
      var units = last.sizes
        ? Object.values(last.sizes).reduce(function (s, q) { return s + (parseInt(q) || 0); }, 0)
        : 0;
      var sub = (last.printMethod || '') +
        (last.colour ? ' - ' + last.colour : '') +
        (units ? ' - ' + units + ' units' : '');
      showPopup({
        title: last.productTitle || 'Order line added',
        sub: sub.replace(/^[ -]+/, ''),
        imgSrc: last.productImage || ''
      });
    }
    _lastLICount = newCount;
  });

  // Any /cart/add.js made through window.fetch (order sections, theme product
  // forms) gets the popup. The builder bridge uses _rawFetch and shows its own.
  var _nativeFetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var isAddToCart = false;
    try {
      var parsed = new URL(url, window.location.origin);
      var p = parsed.pathname;
      isAddToCart = (p === '/cart/add' || p === '/cart/add.js');
    } catch (e) {
      isAddToCart = (url.indexOf('/cart/add.js') !== -1);
    }
    var promise = _nativeFetch.apply(this, arguments);
    if (isAddToCart && !onCartPage()) {
      promise.then(function (response) {
        if (!response.ok) return response;
        var clone = response.clone();
        clone.json().then(function (data) {
          var item = data.items ? data.items[0] : data;
          if (!item) return;
          var props = item.properties || {};
          if (liIsBrief(props)) {
            var b = liBriefInfo(props);
            showPopup({ title: b.title, sub: b.sub, imgSrc: b.img, stayLabel: 'Keep designing' });
            return;
          }
          var imgSrc = item.featured_image && item.featured_image.url
            ? item.featured_image.url : (item.image || '');
          if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          var units = parseInt(props['Total units'] || props['Quantity'], 10) || item.quantity || 1;
          var sub = item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title + ' - ' + units + ' units'
            : units + ' unit' + (units !== 1 ? 's' : '');
          showPopup({
            title: item.product_title || item.title || 'Item added',
            sub: sub,
            imgSrc: imgSrc
          });
        }).catch(function () {});
        return response;
      }).catch(function () {});
    }
    return promise;
  };

  window.LIShowCartPopup = showPopup;
  window.LIHideCartPopup = hidePopup;

})();


// ── Cart page renderer ────────────────────────────────────────────────────────

(function () {
  var CONTAINER_ID = 'li-items-container';
  function fmt(n) { return '$' + parseFloat(n || 0).toFixed(2); }
  function fixSrc(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : (u || ''); }

  /* ── FIX 1: money property lookup ──────────────────────────────────────────
     Order sections do not agree on what they call the engine's line total.
     dtf-order and screenprint write "Order total", footy shorts writes
     "Grand total", older sections wrote "Line total" or "Total". This chain
     used to start at "Grand total", so every line whose only money property
     was "Order total" (screenprint, caps, bar mats, accessories) fell through
     to item.original_line_price, which is Shopify's variant price x quantity
     and NOT the engine's figure. On order #1039 that showed a bar mat line as
     $60,000.00 against the engine's stated $1,100.00.
     Shopify's own number stays as a last resort only.
     ──────────────────────────────────────────────────────────────────────── */
  var MONEY_PROPS = ['Order total', 'Grand total', 'Line total', 'Total'];
  function propMoney(props) {
    if (!props) return null;
    for (var i = 0; i < MONEY_PROPS.length; i++) {
      var raw = props[MONEY_PROPS[i]];
      if (raw === undefined || raw === null || raw === '') continue;
      var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (!isNaN(n)) return n;
    }
    return null;
  }

  /* ── FIX 3 helper: the engine's own unit count ─────────────────────────────
     Shopify's line quantity is what an invoice and the order record read, so
     when it disagrees with the engine the billing is wrong, not just the
     display. The sections state the true count on the line itself:
     "Total units" (dtf/screenprint) or "Quantity" (accessories/bar mats).
     ──────────────────────────────────────────────────────────────────────── */
  /* Only the order sections' own lines get their quantity rewritten. A plain
     product that happens to carry a property called "Quantity" must be left
     alone, or we would silently change a cart line nobody asked us to touch. */
  function isEngineLine(props) {
    if (!props) return false;
    if (props['Print method'] || props['Order type'] || props['Product type'] || props['Tier']) return true;
    return Object.keys(props).some(function (k) { return /^Line \d+/i.test(k); });
  }

  /* Rebuild the whole Tier string from the table the section published, so the
     label and the prices are always computed from the same live unit count. */
  function tierStringFor(rawTable, units) {
    var table;
    try { table = JSON.parse(rawTable); } catch (e) { return null; }
    if (!Array.isArray(table) || !table.length) return null;
    var best = null;
    table.forEach(function (t) {
      var min = parseInt(t.min, 10);
      if (!isFinite(min)) return;
      if (units >= min && (!best || min > parseInt(best.min, 10))) best = t;
    });
    if (!best) return 'Below minimum';
    var parts = Object.keys(best.p || {}).map(function (k) { return k + ' ' + best.p[k]; });
    return parseInt(best.min, 10) + '+ units' + (parts.length ? ' | ' + parts.join(' | ') : '');
  }

  function statedUnits(props) {
    if (!props) return null;
    var raw = props['Total units'];
    if (raw === undefined || raw === null || raw === '') raw = props['Quantity'];
    if (raw === undefined || raw === null || raw === '') return null;
    var n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    return (isFinite(n) && n > 0) ? n : null;
  }

  window.liRemoveLine = function(lineIndex) {
    _rawFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    }).then(function() { render(); }).catch(function() { render(); });
  };

  /* One delegated listener for every remove button (no inline onclick).
     Shopify lines carry data-li-line, saved order-builder lines data-li-id. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.li-item-remove') : null;
    if (!btn || !document.getElementById(CONTAINER_ID)) return;
    e.preventDefault();
    var card = btn.closest('.li-item');
    if (card) card.style.opacity = '0.4';
    btn.disabled = true;
    if (btn.dataset.liLine) window.liRemoveLine(parseInt(btn.dataset.liLine, 10));
    else if (btn.dataset.liId && window.LIOrder) window.LIOrder.remove(btn.dataset.liId);
  });

  /* Builder brief lines are $0 quote requests. Show the design itself, the
     client's notes and a link back into the builder, never "$0.00". */
  function renderBriefItem(item, removeBtn) {
    var b = liBriefInfo(item.properties || {});
    var imgHtml = b.img
      ? '<img class="li-item-img" src="'+liEsc(b.img)+'" alt="">'
      : '<div class="li-item-img-ph">design</div>';
    var body = '';
    if (b.notes) body += '<p class="li-brief-notes">'+liEsc(b.notes)+'</p>';
    if (b.link)  body += '<a class="li-brief-link" href="'+liEsc(b.link)+'" target="_blank" rel="noopener">View design</a>';
    return '<div class="li-item li-item--brief">'+
      '<div class="li-item-top">'+imgHtml+
        '<div class="li-item-body">'+
          '<span class="li-item-badge">Design brief</span>'+
          '<span class="li-item-name">'+liEsc(b.title)+'</span>'+
          '<p class="li-item-sub">'+liEsc(b.sub)+'</p>'+
        '</div>'+
        removeBtn+
      '</div>'+
      (body ? '<div class="li-divider"></div>'+body : '')+
      '<div class="li-item-summary"><div class="li-sum-cell"><span class="li-sum-lbl">Price</span><span class="li-sum-val">Quoted after review</span></div></div>'+
    '</div>';
  }

  function renderLIItem(item) {
    var sizeEntries = Object.entries(item.sizes || {});
    var chips = sizeEntries.map(function(e){
      return '<span class="li-size-chip"><span class="li-size-chip-label">'+e[0]+'</span><span class="li-size-chip-qty">'+e[1]+'</span></span>';
    }).join('');
    var img = fixSrc(item.productImage);
    var imgHtml = img ? '<img class="li-item-img" src="'+img+'" alt="">' : '<div class="li-item-img-ph">no image</div>';
    var summary = '';
    if (item.tier)             summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Tier</span><span class="li-sum-val">'+item.tier+'</span></div>';
    if (item.garmentsSubtotal) summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Garments</span><span class="li-sum-val">'+fmt(item.garmentsSubtotal)+'</span></div>';
    if (item.setupFee)         summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Setup fee</span><span class="li-sum-val">'+fmt(item.setupFee)+'</span></div>';
    if (item.baggingFee)       summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Bagging</span><span class="li-sum-val">'+fmt(item.baggingFee)+'</span></div>';
    if (item.colourSurcharge)  summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Colour surcharge</span><span class="li-sum-val">'+fmt(item.colourSurcharge)+'</span></div>';
    summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Line total</span><span class="li-sum-val li-sum-val--lg">'+fmt(item.lineTotal)+'</span></div>';
    var units = sizeEntries.reduce(function(s,e){return s+(parseInt(e[1])||0);},0);
    var sub = (item.design||item.productTitle||'') + (item.colour?' - '+item.colour:'') + ' - '+units+' units';
    return '<div class="li-item">' +
      '<div class="li-item-top">'+imgHtml+
        '<div class="li-item-body">'+
          '<span class="li-item-badge">'+(item.printMethod||'Order')+'</span>'+
          '<a href="'+(item.productUrl||'#')+'" class="li-item-name">'+item.productTitle+'</a>'+
          '<p class="li-item-sub">'+sub+'</p>'+
        '</div>'+
        '<button type="button" class="li-item-remove" data-li-id="'+liEsc(item.id)+'" aria-label="Remove">&times;</button>'+
      '</div>'+
      '<div class="li-divider"></div>'+
      '<div class="li-garment-label">'+(item.garmentType||'Sizes')+'</div>'+
      '<div class="li-size-grid">'+chips+'</div>'+
      '<div class="li-item-summary">'+summary+'</div>'+
    '</div>';
  }

  // ── Parse DTF line properties into clean display objects ──
  // Handles new grouped format: "Line 1 - Design - Colour": "Adult Hood: L x1 XL x1"
  // Also handles old flat format: "Line 1 Adult Hood XS": 10
  function parseDTFLines(props) {
    var lines = [];
    var maxLine = 0;
    Object.keys(props).forEach(function(k) {
      var m = k.match(/^Line (\d+)/i);
      if (m) maxLine = Math.max(maxLine, parseInt(m[1]));
    });
    if (maxLine === 0) return lines;

    for (var n = 1; n <= maxLine; n++) {
      var prefix = 'Line ' + n;

      // ── New grouped format: key is "Line N - Design - Colour", value is "Adult Hood: L x1 XL x1 | Kids Tee: K6 x3" ──
      var newKey = null;
      var newVal = null;
      Object.keys(props).forEach(function(k) {
        if (k === prefix) return;
        if (k.indexOf(prefix) !== 0) return;
        var rest = k.slice(prefix.length);
        // New format keys start with " - " after "Line N"
        if (rest.indexOf(' - ') === 0) {
          var val = String(props[k]);
          // Value contains garment data like "Adult Hood: L x1"
          if (val.indexOf(':') > -1) {
            newKey = k;
            newVal = val;
          }
        }
      });

      if (newKey) {
        // Extract heading from key: "Line 1 - ROCK HARD GREEN 26 - Black - No Zip" -> "ROCK HARD GREEN 26 | Black | No Zip"
        var headRaw = newKey.slice(prefix.length).replace(/^ - /, '');
        var heading = headRaw.split(' - ').filter(function(p){ return p !== 'No Zip'; }).join(' | ');
        var notes = props[prefix + ' Notes'] || '';
        // Parse garment groups from value: "Adult Hood: L x1 XL x1 | Kids Tee: K6 x3"
        var garmentGroups = newVal.split(' | ').map(function(g){ return g.trim(); }).filter(Boolean);
        lines.push({ heading: heading, garmentGroups: garmentGroups, notes: notes });
        continue;
      }

      // ── Old flat format: "Line 1 Adult Hood XS": 10 ──
      var design    = props[prefix + ' Design'] || '';
      var colour    = props[prefix + ' Colour'] || '';
      var hoodStyle = props[prefix + ' Hood style'] || '';
      var style     = props[prefix + ' Style'] || '';
      var notes2    = props[prefix + ' Notes'] || '';

      var heading2 = '';
      if (design)    heading2 += design;
      if (colour)    heading2 += (heading2 ? ' | ' : '') + colour;
      if (hoodStyle && hoodStyle !== 'No Zip') heading2 += (heading2 ? ' | ' : '') + hoodStyle;
      if (style)     heading2 += (heading2 ? ' | ' : '') + style;

      var garmentMap = {};
      var garmentOrder = ['Adult tee','Adult Hood','Adult Sweater','Kids tee','Kids hood','Kids Sweater'];
      Object.keys(props).forEach(function(k) {
        if (k.indexOf(prefix + ' ') !== 0) return;
        var suffix = k.slice(prefix.length + 1);
        if (['Design','Colour','Hood style','Style','Notes'].indexOf(suffix) >= 0) return;
        var qty = parseInt(props[k]);
        if (!qty || qty < 1) return;
        var parts = suffix.match(/^(.+?)\s+([^\s]+)$/);
        if (!parts) return;
        var garment = parts[1];
        var size    = parts[2];
        if (!garmentMap[garment]) garmentMap[garment] = [];
        garmentMap[garment].push(size + ' x' + qty);
      });

      var garmentGroups2 = [];
      garmentOrder.forEach(function(g) {
        if (garmentMap[g]) garmentGroups2.push(g + ': ' + garmentMap[g].join(' '));
      });
      Object.keys(garmentMap).forEach(function(g) {
        if (garmentOrder.indexOf(g) < 0) garmentGroups2.push(g + ': ' + garmentMap[g].join(' '));
      });

      if (garmentGroups2.length || heading2) {
        lines.push({ heading: heading2, garmentGroups: garmentGroups2, notes: notes2 });
      }
    }
    return lines;
  }

  // ── Calculate line price from tier properties ──
  function calcDTFLinePrice(props) {
    var tierStr = props['Tier'] || '';
    if (!tierStr || tierStr === 'Below minimum') return null;

    // Parse per-garment prices from Tier: "50+ units | Adult Hood $58.50 | Kids Tee $27.00"
    var prices = {};
    tierStr.split(' | ').forEach(function(part) {
      part = part.trim();
      var m = part.match(/^(.+?)\s+\$(\d+\.?\d*)$/);
      if (m) prices[m[1].trim().toLowerCase()] = parseFloat(m[2]);
    });
    if (Object.keys(prices).length === 0) return null;

    // Parse sizes from line properties
    var total = 0;
    Object.keys(props).forEach(function(k) {
      var v = String(props[k] || '');
      if (v.indexOf(':') < 0) return;
      // Key is "Line 1 - Design - Colour" or similar - value is "Adult Hood: XS x1 S x2 | Kids Tee: K6 x3"
      v.split(' | ').forEach(function(group) {
        var ci = group.indexOf(':');
        if (ci < 0) return;
        var gtype = group.slice(0, ci).trim().toLowerCase();
        var unitPrice = prices[gtype] || 0;
        if (!unitPrice) return;
        var toks = group.slice(ci + 1).trim().split(' ');
        for (var i = 0; i < toks.length - 1; i += 2) {
          var qt = toks[i + 1] || '';
          if (qt.charAt(0) === 'x' || qt.charAt(0) === 'X') {
            total += (parseInt(qt.slice(1)) || 0) * unitPrice;
          }
        }
      });
    });
    return total > 0 ? total : null;
  }

  // ── Render Shopify cart line items ──
  function renderShopifyItem(item, lineIndex, liveDTFUnits) {
    var props = item.properties || {};
    var printMethod = props['Print method'] || '';
    var imgHtml = item.featured_image && item.featured_image.url
      ? '<img class="li-item-img" src="'+fixSrc(item.featured_image.url)+'" alt="">'
      : (item.image ? '<img class="li-item-img" src="'+fixSrc(item.image)+'" alt="">' : '<div class="li-item-img-ph">no image</div>');
    var removeBtn = '<button type="button" class="li-item-remove" data-li-line="'+lineIndex+'" aria-label="Remove">&times;</button>';

    // ── Builder design brief (Lovable) ──
    if (liIsBrief(props)) return renderBriefItem(item, removeBtn);

    // ── DTF order ──
    var isDTF = (printMethod === 'DTF' || printMethod === 'Digital');
    var displayMethod = (printMethod === 'DTF' || printMethod === 'Digital') ? 'Digital' : printMethod;
    var hasLineProps = Object.keys(props).some(function(k){ return /^Line \d+/i.test(k); });

    if (isDTF && hasLineProps) {
      var storedTier  = props['Tier'] || '';
      // Prefer the engine's stated unit count over Shopify's line quantity.
      var totalUnits  = statedUnits(props) || item.quantity || '';
      var dtfLines    = parseDTFLines(props);
      // Recalculate tier label from live cart total, keep per-garment prices from stored prop
      var liveUnits = liveDTFUnits || 0;
      var tier;
      if (props['_tier_table']) {
        tier = tierStringFor(props['_tier_table'], liveUnits) || storedTier || 'Below minimum';
      } else {
        // No table: show exactly what the section wrote rather than inventing
        // a label that disagrees with the prices beside it.
        tier = storedTier || 'Below minimum';
      }

      var linesHtml = dtfLines.map(function(line) {
        var garmentRows = line.garmentGroups.map(function(g) {
          var ci = g.indexOf(':');
          if (ci < 0) return '<div style="font-size:12px;color:rgba(var(--color-foreground),0.7);margin:3px 0;">' + g + '</div>';
          var gtype = g.slice(0, ci).trim();
          var sizes = g.slice(ci + 1).trim();
          // Parse "S x2 M x3 L x27" into chips
          var chips = '';
          var tokens = sizes.split(' ');
          for (var ti = 0; ti < tokens.length - 1; ti += 2) {
            var sz = tokens[ti];
            var qstr = tokens[ti + 1] || '';
            if (qstr.charAt(0) === 'x' || qstr.charAt(0) === 'X') {
              chips += '<span style="display:inline-flex;align-items:center;background:rgba(var(--color-foreground),0.06);border:1px solid rgba(var(--color-foreground),0.12);border-radius:4px;overflow:hidden;margin:2px 3px 2px 0;font-size:11px;">' +
                '<span style="padding:2px 5px;font-weight:600;color:rgb(var(--color-foreground));">' + sz + '</span>' +
                '<span style="padding:2px 6px 2px 4px;color:rgba(var(--color-foreground),0.9);background:rgba(var(--color-foreground),0.1);border-left:1px solid rgba(var(--color-foreground),0.12);font-weight:500;">' + qstr.slice(1) + '</span>' +
              '</span>';
            }
          }
          return '<div style="margin:4px 0 2px;">' +
            '<span style="font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;color:rgba(var(--color-foreground),0.4);display:block;margin-bottom:3px;">' + gtype + '</span>' +
            '<div style="display:flex;flex-wrap:wrap;">' + chips + '</div>' +
          '</div>';
        }).join('');
        return '<div class="li-group-line">' +
          '<div class="li-group-line-header" style="margin-bottom:6px;"><strong>' + (line.heading || 'Line') + '</strong></div>' +
          garmentRows +
          (line.notes ? '<div style="font-size:11px;color:rgba(var(--color-foreground),0.45);font-style:italic;margin-top:4px;">' + line.notes + '</div>' : '') +
        '</div>';
      }).join('<div style="height:1px;background:rgba(var(--color-foreground),0.08);margin:8px 0;"></div>');

      var summary = '';
      if (tier)       summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Tier</span><span class="li-sum-val">' + tier + '</span></div>';
      if (totalUnits) summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Total units</span><span class="li-sum-val">' + totalUnits + '</span></div>';

      return '<div class="li-item">' +
        '<div class="li-item-top">' + imgHtml +
          '<div class="li-item-body">' +
            '<span class="li-item-badge">' + displayMethod + '</span>' +
            '<a href="' + item.url + '" class="li-item-name">' + item.product_title + '</a>' +
            '<p class="li-item-sub">' + dtfLines.length + ' line' + (dtfLines.length !== 1 ? 's' : '') + (totalUnits ? ' - ' + totalUnits + ' units' : '') + '</p>' +
          '</div>' +
          removeBtn +
        '</div>' +
        '<div class="li-divider"></div>' +
        linesHtml +
        (summary ? '<div class="li-item-summary">' + summary + '</div>' : '') +
      '</div>';
    }

    // ── Old multi-design packed format ──
    var lineKeys = Object.keys(props).filter(function(k){ return /^Line \d+ Design$/i.test(k); });
    if (lineKeys.length > 0) {
      var maxLine = 0;
      Object.keys(props).forEach(function(k){
        var m = k.match(/^Line (\d+)/i);
        if (m) maxLine = Math.max(maxLine, parseInt(m[1]));
      });
      var linesHtml2 = '';
      for (var n = 1; n <= maxLine; n++) {
        var pfx = 'Line ' + n + ' ';
        var lineDesign    = props[pfx+'Design'] || '';
        var lineHoodStyle = props[pfx+'Hood style'] || props[pfx+'Hood Style'] || '';
        var header = lineDesign + (lineHoodStyle && lineHoodStyle !== 'No Zip' ? ' - '+lineHoodStyle : '');
        var sizeChips = '';
        var lineUnits = 0;
        Object.keys(props).forEach(function(k){
          if (k.indexOf(pfx) === 0) {
            var suffix = k.replace(pfx, '');
            if (['Design','Hood style','Hood Style','Colour'].indexOf(suffix) >= 0) return;
            var val = parseInt(props[k]);
            if (val && val > 0) {
              sizeChips += '<span class="li-size-chip"><span class="li-size-chip-label">'+suffix+'</span><span class="li-size-chip-qty">'+val+'</span></span>';
              lineUnits += val;
            }
          }
        });
        if (!lineDesign && !sizeChips) continue;
        var lineNum = maxLine > 1 ? '<span class="li-line-num">'+n+'</span> ' : '';
        linesHtml2 += '<div class="li-group-line"><div class="li-group-line-header">'+lineNum+'<strong>'+header+'</strong>'+(lineUnits?' - '+lineUnits+' units':'')+'</div>';
        if (sizeChips) linesHtml2 += '<div class="li-size-grid" style="margin:8px 0;">'+sizeChips+'</div>';
        linesHtml2 += '</div>';
        if (n < maxLine) linesHtml2 += '<div style="height:1px;background:var(--li-border);margin:8px 0;"></div>';
      }
      var packedMoney = propMoney(props);
      var grandTotal2 = packedMoney !== null ? fmt(packedMoney) : '$'+(item.original_line_price/100).toFixed(2);
      var tier2 = props['Tier'] || '';
      var summary2 = '';
      if (tier2) summary2 += '<div class="li-sum-cell"><span class="li-sum-lbl">Tier</span><span class="li-sum-val">'+tier2+'</span></div>';
      summary2 += '<div class="li-sum-cell"><span class="li-sum-lbl">Total</span><span class="li-sum-val li-sum-val--lg">'+grandTotal2+'</span></div>';
      return '<div class="li-item">'+
        '<div class="li-item-top">'+imgHtml+
          '<div class="li-item-body">'+
            (printMethod ? '<span class="li-item-badge">'+(printMethod==='DTF'||printMethod==='Digital'?'Digital':printMethod)+'</span>' : '')+
            '<a href="'+item.url+'" class="li-item-name">'+item.product_title+'</a>'+
            '<p class="li-item-sub">'+maxLine+' design line'+(maxLine!==1?'s':'')+' - '+grandTotal2+'</p>'+
          '</div>'+
          removeBtn+
        '</div>'+
        '<div class="li-divider"></div>'+
        linesHtml2+
        '<div class="li-item-summary">'+summary2+'</div>'+
      '</div>';
    }

    // ── Standard product ──
    // Money and bookkeeping keys render as summary rows, not as size chips.
    var metaKeys = ['Print method','Design','Colour','Garment type','Tier','Garments subtotal',
      'Screen setup fee','Screen setup','Bagging fee','Individual bagging','Line total','Colour surcharge','Total',
      'Order total','Grand total','Total units','Quantity','Per unit price','Order type','Product type',
      'Print locations','Location surcharge','New design fee','Production','Stripes','Embroidery locations',
      'Cap type','Per cap price','Caps subtotal','Notes','_design_key'];
    var design2 = props['Design'] || '';
    var chips = Object.entries(props)
      .filter(function(e){ return e[1] && metaKeys.indexOf(e[0]) < 0 && String(e[0]).charAt(0) !== '_'; })
      .map(function(e){
        return '<span class="li-size-chip"><span class="li-size-chip-label">'+e[0]+'</span><span class="li-size-chip-qty">'+e[1]+'</span></span>';
      }).join('');
    var summary3 = '';
    if (props['Tier'])              summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Tier</span><span class="li-sum-val">'+props['Tier']+'</span></div>';
    if (props['Garments subtotal']) summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Garments</span><span class="li-sum-val">'+props['Garments subtotal']+'</span></div>';
    if (props['Screen setup fee'])  summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Setup fee</span><span class="li-sum-val">'+props['Screen setup fee']+'</span></div>';
    if (props['Bagging fee'])       summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Bagging</span><span class="li-sum-val">'+props['Bagging fee']+'</span></div>';
    if (props['Colour surcharge'])  summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Colour surcharge</span><span class="li-sum-val">'+props['Colour surcharge']+'</span></div>';
    var standardMoney = propMoney(props);
    var lineTotal3 = standardMoney !== null ? fmt(standardMoney) : '$'+(item.original_line_price/100).toFixed(2);
    summary3 += '<div class="li-sum-cell"><span class="li-sum-lbl">Total</span><span class="li-sum-val li-sum-val--lg">'+lineTotal3+'</span></div>';
    var shownUnits = statedUnits(props) || item.quantity;
    var sub3;
    if (design2) {
      sub3 = design2 + (props['Colour 1']||props['Colour'] ? ' - '+(props['Colour 1']||props['Colour']) : '') + ' - '+shownUnits+' units';
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      sub3 = item.variant_title;
    } else {
      sub3 = shownUnits + ' unit' + (shownUnits !== 1 ? 's' : '');
    }
    if (!design2 && !chips && item.variant_title && item.variant_title !== 'Default Title') {
      chips = item.variant_title.split(' / ').map(function(v){
        return '<span class="li-size-chip"><span class="li-size-chip-qty">'+v.trim()+'</span></span>';
      }).join('');
    }
    return '<div class="li-item">'+
      '<div class="li-item-top">'+imgHtml+
        '<div class="li-item-body">'+
          (printMethod ? '<span class="li-item-badge">'+(printMethod==='DTF'||printMethod==='Digital'?'Digital':printMethod)+'</span>' : '')+
          '<a href="'+item.url+'" class="li-item-name">'+item.product_title+'</a>'+
          '<p class="li-item-sub">'+sub3+'</p>'+
        '</div>'+
        removeBtn+
      '</div>'+
      ((chips||summary3) ? '<div class="li-divider"></div>' : '')+
      (chips ? '<div class="li-size-grid">'+chips+'</div>' : '')+
      (summary3 ? '<div class="li-item-summary">'+summary3+'</div>' : '')+
    '</div>';
  }

  // ── Main render ──
  function render() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    _rawFetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){ doRender(liItems, cart.items || []); })
      .catch(function(){ doRender(liItems, []); });
  }

  function doRender(liItems, shopifyItems) {
    var container = document.getElementById(CONTAINER_ID);
    var sidebar   = document.getElementById('li-sidebar-rows');
    var totalEl   = document.getElementById('li-total');
    var countLbl  = document.getElementById('li-item-count-label');
    if (!container) return;

    var total = liItems.length + shopifyItems.length;

    var quoteNote = document.getElementById('li-quote-note');
    var submitEl  = document.getElementById('li-submit-btn');

    if (total === 0) {
      // Copy and links come from the hidden #li-cart-data div in the section.
      // /collections/all already redirects guests to The Range and clients
      // to their own collection (layout/theme.liquid).
      var meta = document.getElementById('li-cart-data');
      var ds = meta ? meta.dataset : {};
      var shopUrl = ds.shopUrl || '/collections/all';
      var builderUrl = ds.builderUrl || '/pages/builder';
      var isClient = ds.loggedIn === 'true';
      container.innerHTML =
        '<div class="li-empty"><h2>Your order is empty</h2>'+
        '<p>'+(isClient ? 'Pick from your range, or design new headwear in the builder.' : 'Pick from The Range, or design your own headwear in the builder.')+'</p>'+
        '<div class="li-empty-actions">'+
          '<a href="'+liEsc(shopUrl)+'" class="li-btn-primary">'+(isClient ? 'Your range' : 'Shop The Range')+'</a>'+
          '<a href="'+liEsc(builderUrl)+'" class="li-btn-secondary">Open the builder</a>'+
        '</div></div>';
      if (sidebar)  sidebar.innerHTML = '<div class="li-sidebar-row" style="color:var(--li-muted);font-size:13px;">No lines yet</div>';
      if (totalEl)  totalEl.textContent = '$0.00';
      if (countLbl) countLbl.textContent = '0 lines';
      if (quoteNote) quoteNote.hidden = true;
      if (submitEl) submitEl.disabled = true;
      return;
    }
    if (submitEl) submitEl.disabled = false;

    var html = [], sidebarHtml = [], grand = 0;

    // Group localStorage items
    var liGroups = [];
    var liGroupMap = {};
    liItems.forEach(function(item) {
      var key = (item.productId || item.productTitle) + '|' + item.printMethod;
      if (!liGroupMap[key]) {
        liGroupMap[key] = { key: key, productId: item.productId, productTitle: item.productTitle,
          productUrl: item.productUrl, productImage: item.productImage,
          printMethod: item.printMethod, lines: [], totalLineTotal: 0 };
        liGroups.push(liGroupMap[key]);
      }
      liGroupMap[key].lines.push(item);
      liGroupMap[key].totalLineTotal += parseFloat(item.lineTotal || 0);
    });

    liGroups.forEach(function(group) {
      grand += group.totalLineTotal;
      html.push(renderLIGroup(group));
      sidebarHtml.push(
        '<div class="li-sidebar-row">'+
          '<span class="li-sidebar-row-lbl">'+group.productTitle.substring(0,28)+
            ' <span style="font-size:11px;opacity:0.55;">('+group.printMethod+')</span></span>'+
          '<span class="li-sidebar-row-val">'+fmt(group.totalLineTotal)+'</span>'+
        '</div>'
      );
    });

    // Calculate live tier from total DTF units across all cart items
    var liveDTFUnits = 0;
    shopifyItems.forEach(function(item) {
      var p = item.properties || {};
      var pm = p['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') liveDTFUnits += statedUnits(p) || item.quantity || 0;
    });
    // Sync stored Tier property and line quantities so checkout and the invoice agree
    syncCartLines(shopifyItems);

    var briefCount = 0;
    shopifyItems.forEach(function(item, i){
      html.push(renderShopifyItem(item, i + 1, liveDTFUnits));
      if (liIsBrief(item.properties)) {
        briefCount++;
        sidebarHtml.push(
          '<div class="li-sidebar-row">'+
            '<span class="li-sidebar-row-lbl">'+liEsc(liBriefInfo(item.properties).title)+'</span>'+
            '<span class="li-sidebar-row-val" style="font-weight:500;color:var(--li-muted);">Quote</span>'+
          '</div>'
        );
        return;
      }
      var pm3 = (item.properties || {})['Print method'] || '';
      var isDTF3 = pm3 === 'DTF' || pm3 === 'Digital';
      var calcedPrice = isDTF3 ? calcDTFLinePrice(item.properties || {}) : null;
      var propPrice = propMoney(item.properties);
      var linePrice = calcedPrice !== null ? calcedPrice
        : propPrice !== null ? propPrice
        : item.original_line_price / 100;
      grand += linePrice;
      var pm2 = item.properties && item.properties['Print method'] ? item.properties['Print method'] : '';
      var method = pm2 ? ' ('+(pm2==='DTF'||pm2==='Digital'?'Digital':pm2)+')' : '';
      var label  = item.properties && item.properties['Design'] ? item.properties['Design'] : item.product_title;
      sidebarHtml.push(
        '<div class="li-sidebar-row">'+
          '<span class="li-sidebar-row-lbl">'+label.substring(0,28)+
            '<span style="font-size:11px;opacity:0.55;">'+method+'</span></span>'+
          '<span class="li-sidebar-row-val">'+fmt(linePrice)+'</span>'+
        '</div>'
      );
    });

    container.innerHTML = html.join('');
    if (sidebar)  sidebar.innerHTML = sidebarHtml.join('');
    if (totalEl)  totalEl.textContent = fmt(grand);
    if (countLbl) countLbl.textContent = (liGroups.length + shopifyItems.length) + ' line' + ((liGroups.length + shopifyItems.length) !== 1 ? 's' : '');
    if (quoteNote) {
      quoteNote.hidden = briefCount === 0;
      quoteNote.textContent = briefCount
        ? 'Plus ' + briefCount + ' design brief' + (briefCount !== 1 ? 's' : '') + ', quoted after we review ' + (briefCount !== 1 ? 'them' : 'it') + '.'
        : '';
    }

    // DTF minimum check
    if (window.location.pathname !== '/cart') return;
    var totalDTFUnits = 0;
    shopifyItems.forEach(function(item) {
      var p = item.properties || {};
      var pm = p['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') totalDTFUnits += statedUnits(p) || item.quantity || 0;
    });
    var DTF_MINIMUM = 25;
    var dtfWarning = document.getElementById('li-dtf-minimum-warning');
    var submitBtn  = document.getElementById('li-submit-btn');
    if (totalDTFUnits > 0 && totalDTFUnits < DTF_MINIMUM) {
      if (!dtfWarning) {
        dtfWarning = document.createElement('div');
        dtfWarning.id = 'li-dtf-minimum-warning';
        dtfWarning.style.cssText = 'margin:12px 0;padding:12px 16px;background:rgba(231,76,60,0.08);border:1px solid rgba(231,76,60,0.3);border-radius:6px;font-size:1.3rem;color:#e74c3c;line-height:1.5;';
        var sidebarEl = document.getElementById('li-sidebar-rows');
        if (sidebarEl && sidebarEl.parentElement) {
          sidebarEl.parentElement.insertBefore(dtfWarning, sidebarEl.nextSibling);
        } else if (container.parentElement) {
          container.parentElement.appendChild(dtfWarning);
        }
      }
      dtfWarning.innerHTML = '&#9888; Digital minimum is ' + DTF_MINIMUM + ' units total - you have ' + totalDTFUnits + '. Add ' + (DTF_MINIMUM - totalDTFUnits) + ' more to submit.';
      dtfWarning.style.display = 'block';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.style.opacity = '0.4'; submitBtn.style.cursor = 'not-allowed'; }
    } else {
      if (dtfWarning) dtfWarning.style.display = 'none';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.style.opacity = ''; submitBtn.style.cursor = ''; }
    }
  }

  function renderLIGroup(group) {
    var lines   = group.lines;
    var imgSrc  = fixSrc(group.productImage || '');
    var imgHtml = imgSrc ? '<img class="li-item-img" src="'+imgSrc+'" alt="">' : '<div class="li-item-img-ph">no image</div>';
    var linesHtml = lines.map(function(item, idx) {
      var sizeEntries = Object.entries(item.sizes || {});
      var chips = sizeEntries.map(function(e){
        return '<span class="li-size-chip"><span class="li-size-chip-label">'+e[0]+'</span><span class="li-size-chip-qty">'+e[1]+'</span></span>';
      }).join('');
      var units = sizeEntries.reduce(function(s,e){return s+(parseInt(e[1])||0);},0);
      var lineNum = lines.length > 1 ? '<span class="li-line-num">'+(idx+1)+'</span> ' : '';
      var designColour = item.design + (item.colour ? ' - '+item.colour : '');
      var summary = '';
      if (item.tier)             summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Tier</span><span class="li-sum-val">'+item.tier+'</span></div>';
      if (item.garmentsSubtotal) summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Garments</span><span class="li-sum-val">'+fmt(item.garmentsSubtotal)+'</span></div>';
      if (item.setupFee)         summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Setup</span><span class="li-sum-val">'+fmt(item.setupFee)+'</span></div>';
      if (item.baggingFee)       summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Bagging</span><span class="li-sum-val">'+fmt(item.baggingFee)+'</span></div>';
      summary += '<div class="li-sum-cell"><span class="li-sum-lbl">Line total</span><span class="li-sum-val li-sum-val--lg">'+fmt(item.lineTotal)+'</span></div>';
      return '<div class="li-group-line">' +
        '<div class="li-group-line-header">'+lineNum+'<strong>'+designColour+'</strong> - '+units+' units'+
          '<button type="button" class="li-item-remove" style="margin-left:auto;font-size:16px;opacity:0.5;" data-li-id="'+liEsc(item.id)+'" aria-label="Remove">&times;</button>'+
        '</div>'+
        '<div class="li-size-grid" style="margin:8px 0;">'+chips+'</div>'+
        (summary ? '<div class="li-item-summary">'+summary+'</div>' : '')+
      '</div>';
    }).join('<div style="height:1px;background:var(--li-border);margin:12px 0;"></div>');

    return '<div class="li-item">'+
      '<div class="li-item-top">'+imgHtml+
        '<div class="li-item-body">'+
          '<span class="li-item-badge">'+group.printMethod+'</span>'+
          '<a href="'+(group.productUrl||'#')+'" class="li-item-name">'+group.productTitle+'</a>'+
          '<p class="li-item-sub">'+lines.length+' design line'+(lines.length!==1?'s':'')+' - '+fmt(group.totalLineTotal)+'</p>'+
        '</div>'+
      '</div>'+
      '<div class="li-divider"></div>'+
      linesHtml+
    '</div>';
  }

  (function() {
    var s = document.createElement('style');
    s.textContent = '.li-group-line { padding: 4px 0; } .li-group-line-header { display:flex; align-items:center; gap:6px; font-size:13px; color:rgb(var(--color-foreground)); flex-wrap:wrap; } .li-line-num { display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; background:rgb(var(--color-foreground)); color:rgb(var(--color-background)); border-radius:50%; font-size:11px; font-weight:700; flex-shrink:0; }';
    document.head.appendChild(s);
  })();

  /* ── Sync cart lines to what the engine actually said ──────────────────────
     Two corrections, both written back with /cart/change.js:

     FIX 2  The tier label used to come out as "100++ units", because the label
            already carries its own "+" and the old code appended "+ units".

     FIX 3  Shopify's line quantity is what the order record and the invoice
            read. The sections state the real count on the line itself
            ("Total units", or "Quantity" on accessories and bar mats), and the
            two had drifted apart: order #1039 carried 386 units of adult tees
            on a line Shopify recorded as quantity 50, and 50 bar mats on a
            line recorded as 100. Where the engine states a count, it wins.

     _syncAttempts caps the write/re-render cycle so a line that will not
     settle cannot loop.
     ──────────────────────────────────────────────────────────────────────── */
  var _syncPending = false;
  var _syncAttempts = 0;
  function syncCartLines(shopifyItems) {
    if (_syncPending || _syncAttempts >= 3) return;

    var totalDTF = 0;
    shopifyItems.forEach(function(item) {
      var p = item.properties || {};
      var pm = p['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') totalDTF += statedUnits(p) || item.quantity || 0;
    });

    var updates = [];

    shopifyItems.forEach(function(item, i) {
      var props = item.properties || {};
      var pm = props['Print method'] || '';
      var isDTF = (pm === 'DTF' || pm === 'Digital');
      var newProps = null;

      /* Only rewrite Tier when the line carries the table to rebuild it from.
         The old code relabelled from the live count while keeping the prices
         captured at submit, which produced strings whose label and prices
         disagreed. A stale-but-consistent Tier beats a fresh-but-wrong one, so
         a line without the table is left exactly as the section wrote it. */
      if (isDTF && totalDTF > 0 && props['_tier_table']) {
        var storedTier = props['Tier'] || '';
        var correctTier = tierStringFor(props['_tier_table'], totalDTF);
        if (correctTier && storedTier !== correctTier) {
          newProps = {};
          Object.keys(props).forEach(function(k) { newProps[k] = props[k]; });
          newProps['Tier'] = correctTier;
        }
      }

      var stated = isEngineLine(props) ? statedUnits(props) : null;
      var qtyWrong = (stated !== null && stated !== item.quantity);

      if (newProps || qtyWrong) {
        updates.push({
          line: i + 1,
          quantity: qtyWrong ? stated : item.quantity,
          properties: newProps || props
        });
      }
    });

    if (updates.length === 0) return;
    _syncPending = true;
    _syncAttempts++;

    var promises = updates.map(function(u) {
      return _rawFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(u)
      });
    });

    Promise.all(promises).then(function() {
      _syncPending = false;
      render();
    }).catch(function() {
      _syncPending = false;
    });
  }

  window.liRenderCart = render;
  window.addEventListener('li:order:updated', render);

  function observe() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    var parent = container.parentElement;
    if (!parent) return;
    var _renderScheduled = false;
    new MutationObserver(function() {
      var el = document.getElementById(CONTAINER_ID);
      if (el && el.innerHTML.indexOf('Loading your order') > -1) {
        if (_renderScheduled) return;
        _renderScheduled = true;
        setTimeout(function() { _renderScheduled = false; render(); }, 50);
      }
    }).observe(parent, { childList: true, subtree: true });
  }

  function init() { render(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('cart:refresh', render);

})();


/**
 * Lucky Inger: design preselect from the client portal
 * Portal tiles link to /products/x?variant=ID&design=NAME.
 * This opens the order page on that design instead of the first one.
 * - dtf-order / screenprint-order: wraps window.dtfSelectDesign so the
 *   section's own init (which picks option 1) lands on the linked design.
 * - accessories / caps / beanie / bucket / straw: after the section init,
 *   sets the select value and fires its change handler.
 */
(function () {
  'use strict';
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var want = (params.get('design') || '').trim();
  if (!want || !/\/products\//.test(window.location.pathname)) return;
  var wantKey = want.toLowerCase();

  function matchIndex(sel) {
    for (var i = 0; i < sel.options.length; i++) {
      var v = (sel.options[i].value || '').trim().toLowerCase();
      if (v && v === wantKey) return i;
    }
    return -1;
  }

  // DTF + screen print: section defines window.dtfSelectDesign inline
  var pending = true;
  function wrapDtf() {
    var orig = window.dtfSelectDesign;
    if (typeof orig !== 'function' || orig.__liWrapped) return !!orig;
    var wrapped = function (sel) {
      if (pending && sel && sel.id === 'dtf-design-select') {
        pending = false;
        var idx = matchIndex(sel);
        if (idx > 0) sel.selectedIndex = idx;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__liWrapped = true;
    window.dtfSelectDesign = wrapped;
    return true;
  }
  if (!wrapDtf()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (wrapDtf() || tries > 40) clearInterval(t);
    }, 50);
  }

  // Other order sections: plain selects with change listeners
  var OTHER = ['bm-design-select', 'cap-design-select', 'bn-design-select', 'hw-design-select'];
  function applyOthers() {
    OTHER.forEach(function (id) {
      var sel = document.getElementById(id);
      if (!sel) return;
      var idx = matchIndex(sel);
      if (idx < 0 || sel.selectedIndex === idx) return;
      sel.selectedIndex = idx;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function runOthers() {
    applyOthers();
    // second pass in case a section finishes its own init late
    setTimeout(applyOthers, 400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOthers);
  } else {
    runOthers();
  }
})();


/**
 * Lucky Inger: builder order email notification
 * When the cart submit button (#li-submit-btn) is clicked, a snapshot of the
 * order is posted to the lid-proofs Worker (/notify/order), which emails
 * NOTIFY_EMAIL via Resend.
 * - The cart is snapshotted ahead of time (on load and after every cart
 *   render) so nothing async has to happen at click time. The submit can
 *   clear the cart or navigate away immediately and the email still sends.
 * - Sent with navigator.sendBeacon (text/plain, no CORS preflight), falling
 *   back to fetch keepalive. Fire and forget: never blocks or breaks submit.
 * - Optional: add data-customer-email / data-customer-name to a hidden
 *   <div id="li-cart-data"> in the cart section to include who placed it.
 */
(function () {
  'use strict';
  var NOTIFY_URL = 'https://lid-proofs.rhiley-scholes123.workers.dev/notify/order';
  var SUBMIT_ID = 'li-submit-btn';
  var CONTAINER_ID = 'li-items-container';
  var DEDUPE_MS = 15000;

  var _snapshot = null;
  var _lastSent = 0;
  var _snapTimer = null;

  var MONEY_KEYS = ['Order total', 'Grand total', 'Line total', 'Total'];
  function money(props) {
    for (var i = 0; i < MONEY_KEYS.length; i++) {
      var raw = props[MONEY_KEYS[i]];
      if (raw === undefined || raw === null || raw === '') continue;
      var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (!isNaN(n)) return n;
    }
    return null;
  }

  function takeSnapshot() {
    _rawFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { _snapshot = cart; })
      .catch(function () {});
  }

  function scheduleSnapshot() {
    clearTimeout(_snapTimer);
    _snapTimer = setTimeout(takeSnapshot, 300);
  }

  function buildPayload() {
    var cart = _snapshot || { items: [] };
    var meta = document.getElementById('li-cart-data');
    var ds = meta ? meta.dataset : {};
    var totalEl = document.getElementById('li-total');
    var lines = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var clean = {};
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_') return;
        if (props[k] === null || props[k] === undefined || props[k] === '') return;
        clean[k] = String(props[k]);
      });
      var m = money(props);
      lines.push({
        title: item.product_title || item.title || '',
        variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        quantity: item.quantity || 0,
        total: m !== null ? m : (item.original_line_price || 0) / 100,
        url: item.url ? window.location.origin + item.url : '',
        properties: clean
      });
    });

    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    liItems.forEach(function (it) {
      var sizes = it.sizes || {};
      var units = Object.keys(sizes).reduce(function (s, k) { return s + (parseInt(sizes[k]) || 0); }, 0);
      var clean = {};
      Object.keys(sizes).forEach(function (k) { if (parseInt(sizes[k])) clean[k] = String(sizes[k]); });
      if (it.printMethod) clean['Print method'] = String(it.printMethod);
      if (it.tier) clean['Tier'] = String(it.tier);
      lines.push({
        title: it.productTitle || '',
        variant: [it.design, it.colour].filter(Boolean).join(' - '),
        quantity: units,
        total: parseFloat(it.lineTotal) || 0,
        url: it.productUrl ? window.location.origin + it.productUrl : '',
        properties: clean
      });
    });

    return {
      type: 'builder_order',
      submittedAt: new Date().toISOString(),
      page: window.location.href,
      customerEmail: ds.customerEmail || '',
      customerName: ds.customerName || '',
      cartToken: cart.token || '',
      orderTotal: totalEl ? totalEl.textContent.trim() : '',
      lines: lines
    };
  }

  function send(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var ok = navigator.sendBeacon(NOTIFY_URL, new Blob([body], { type: 'text/plain' }));
        if (ok) return;
      }
    } catch (e) {}
    try {
      _rawFetch(NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('#' + SUBMIT_ID) : null;
    if (!btn || btn.disabled) return;
    var now = Date.now();
    if (now - _lastSent < DEDUPE_MS) return;
    var payload = buildPayload();
    if (!payload.lines.length) return;
    _lastSent = now;
    send(payload);
  }

  function watchRenders() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container || !container.parentElement) return;
    new MutationObserver(scheduleSnapshot)
      .observe(container.parentElement, { childList: true, subtree: true });
  }

  function init() {
    if (!document.getElementById(CONTAINER_ID) && !document.getElementById(SUBMIT_ID)) return;
    takeSnapshot();
    watchRenders();
    document.addEventListener('click', onClick, true);
    window.addEventListener('li:order:updated', scheduleSnapshot);
    window.addEventListener('cart:refresh', scheduleSnapshot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Lucky Inger: cart submit (moved out of main-cart-items.liquid)
 * Section <script> blocks are wiped when cart.js re-renders the section, so
 * the handler lives here, delegated from document. Flow stays native:
 * saved order-builder lines -> /cart/add.js (quantity = total units),
 * order note -> /cart/update.js, then Shopify checkout.
 * Real Shopify errors show inline under the button instead of a generic alert.
 */
(function () {
  'use strict';
  var BTN_ID = 'li-submit-btn';

  function fmt(n) { return '$' + parseFloat(n || 0).toFixed(2); }

  function setBusy(btn, busy) {
    var spinner = document.getElementById('li-spinner');
    var label = btn.querySelector('.li-submit-label');
    btn.disabled = busy;
    if (spinner) spinner.style.display = busy ? 'inline-block' : 'none';
    if (label) {
      if (!label.dataset.idle) label.dataset.idle = label.textContent;
      label.textContent = busy ? 'Taking you to checkout' : label.dataset.idle;
    }
  }

  function showError(msg) {
    var el = document.getElementById('li-submit-error');
    if (!el) { alert(msg); return; }
    el.textContent = msg;
    el.hidden = !msg;
  }

  function buildLIItems() {
    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    var out = [];
    liItems.forEach(function (item) {
      var qty = Object.values(item.sizes || {}).reduce(function (s, q) { return s + (parseInt(q) || 0); }, 0);
      if (!qty || !item.variantId) return;
      var props = {};
      props['Print method'] = item.printMethod || '';
      props['Design'] = item.design || '';
      if (item.colour)      props['Colour'] = item.colour;
      if (item.garmentType) props['Garment type'] = item.garmentType;
      Object.entries(item.sizes || {}).forEach(function (e) {
        if (parseInt(e[1]) > 0) props[e[0]] = String(e[1]);
      });
      props['Tier'] = item.tier || '';
      props['Total units'] = String(qty);
      props['Garments subtotal'] = fmt(item.garmentsSubtotal);
      if (item.setupFee)        props['Screen setup fee'] = fmt(item.setupFee);
      if (item.baggingFee)      props['Bagging fee'] = fmt(item.baggingFee);
      if (item.colourSurcharge) props['Colour surcharge'] = fmt(item.colourSurcharge);
      props['Line total'] = fmt(item.lineTotal);
      out.push({ id: item.variantId, quantity: qty, properties: props });
    });
    return out;
  }

  function post(url, body) {
    return _rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(liReadCartJson);
  }

  function submit(btn) {
    showError('');
    setBusy(btn, true);
    var noteEl = document.getElementById('li-note');
    var note = noteEl ? noteEl.value.trim() : '';

    _rawFetch('/cart.js')
      .then(liReadCartJson)
      .then(function (cart) {
        var adds = buildLIItems();
        if (!adds.length && !(cart.items || []).length) throw new Error('Your order is empty.');
        return adds.length ? post('/cart/add.js', { items: adds }) : null;
      })
      .then(function () {
        return note ? post('/cart/update.js', { note: note }) : null;
      })
      .then(function () {
        if (window.LIOrder) window.LIOrder.clear();
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Submit error:', err);
        setBusy(btn, false);
        showError((err && err.message) || 'Something went wrong. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#' + BTN_ID) : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    submit(btn);
  });
})();


/**
 * Lucky Inger: Lovable builder bridge (moved out of lucky-builder.liquid)
 * The section renders a wrapper with data- attributes and an empty iframe.
 * This block:
 *  - builds the iframe src (embed=1, logged-in customer, ?product= from the
 *    page URL) and sets it once, so the app loads a single time
 *  - forwards later ?product= changes to the app via postMessage
 *  - sizes the iframe (viewport fill, or auto-grow from lucky:resize)
 *  - handles lucky:add-to-cart: adds the brief lines natively, keeps the
 *    customer on the builder, and shows the popup with "Review order"
 *  - keeps the "Your order (n)" pill current, since the theme header is
 *    hidden on this page
 */
(function () {
  'use strict';

  function boot(wrap) {
    if (!wrap || wrap.dataset.liBooted) return;
    var iframe = wrap.querySelector('iframe[data-lucky-iframe]');
    var ds = wrap.dataset;
    if (!iframe || !ds.embedUrl) return;
    wrap.dataset.liBooted = '1';
    document.body.classList.add('li-on-builder');

    var allowedOrigin = '';
    try { allowedOrigin = new URL(ds.embedUrl).origin; } catch (e) { return; }

    function parentProduct() {
      try { return new URLSearchParams(window.location.search).get('product'); } catch (e) { return null; }
    }

    // ── iframe src ──
    try {
      var u = new URL(ds.embedUrl);
      u.searchParams.set('embed', '1');
      if (ds.customerEmail) u.searchParams.set('customer_email', ds.customerEmail);
      if (ds.customerName)  u.searchParams.set('customer_name', ds.customerName);
      if (ds.customerId)    u.searchParams.set('customer_id', ds.customerId);
      var p0 = parentProduct();
      if (p0) u.searchParams.set('product', p0);
      iframe.src = u.toString();
    } catch (e) { return; }

    // ── product forwarding ──
    var lastSent = parentProduct();
    function forwardProduct() {
      var p = parentProduct();
      if (!p || p === lastSent) return;
      lastSent = p;
      try { iframe.contentWindow.postMessage({ type: 'lucky:product', product: p }, allowedOrigin); } catch (e) {}
    }
    window.addEventListener('popstate', forwardProduct);
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      if (typeof orig !== 'function' || orig.__liWrapped) return;
      var wrapped = function () {
        var ret = orig.apply(this, arguments);
        forwardProduct();
        return ret;
      };
      wrapped.__liWrapped = true;
      history[fn] = wrapped;
    });

    // ── sizing ──
    var autoGrow = ds.autoGrow === 'true';
    var offD = parseInt(ds.offsetDesktop, 10) || 0;
    var offM = parseInt(ds.offsetMobile, 10) || 0;
    var minD = parseInt(ds.minDesktop, 10) || 800;
    var minM = parseInt(ds.minMobile, 10) || 700;
    function isMobile() { return window.innerWidth < 640; }
    var bar = wrap.querySelector('[data-lucky-bar]');
    function viewportFill() {
      var barH = bar ? bar.offsetHeight : 0;
      var h = Math.max(isMobile() ? minM : minD, window.innerHeight - barH - (isMobile() ? offM : offD));
      iframe.style.height = h + 'px';
    }
    if (autoGrow) {
      iframe.style.height = (isMobile() ? minM : minD) + 'px';
    } else {
      viewportFill();
      window.addEventListener('resize', viewportFill);
      window.addEventListener('orientationchange', viewportFill);
    }

    // ── order pill ──
    var pill = wrap.querySelector('[data-lucky-cart-pill]');
    var pillCount = pill ? pill.querySelector('[data-lucky-cart-count]') : null;
    function refreshPill() {
      if (!pill) return;
      var liCount = window.LIOrder ? window.LIOrder.count() : 0;
      _rawFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = (cart.item_count || 0) + liCount;
          if (pillCount) pillCount.textContent = String(n);
          pill.hidden = n === 0;
        })
        .catch(function () {});
    }
    refreshPill();

    // ── messages from the app ──
    var briefVariantId = ds.briefVariantId || '';
    var adding = false;

    window.addEventListener('message', function (event) {
      if (event.origin !== allowedOrigin) return;
      var data = event.data || {};

      if (data.type === 'lucky:resize' && autoGrow && typeof data.height === 'number') {
        iframe.style.height = Math.max(isMobile() ? minM : minD, data.height) + 'px';
        return;
      }

      if (data.type !== 'lucky:add-to-cart' || !Array.isArray(data.lines) || adding) return;

      var items = data.lines.map(function (line) {
        return {
          id: Number(line.variantId || briefVariantId),
          quantity: parseInt(line.quantity, 10) || 1,
          properties: line.properties || {}
        };
      }).filter(function (item) { return !!item.id; });

      if (!items.length) {
        window.LIShowCartPopup && window.LIShowCartPopup({
          error: true,
          title: 'Your design is saved',
          sub: 'It could not be added to your order. Please contact us and we will sort it out.'
        });
        return;
      }

      adding = true;
      _rawFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(liReadCartJson)
        .then(function () {
          adding = false;
          var first = items[0].properties || {};
          var b = liBriefInfo(first);
          var total = items.reduce(function (s, it) {
            return s + (parseInt((it.properties || {})['Designs'], 10) || 1);
          }, 0);
          window.LIShowCartPopup && window.LIShowCartPopup({
            sticky: true,
            title: items.length === 1 ? b.title : total + ' designs added',
            sub: 'We will quote it after review. Add more designs or review your order.',
            imgSrc: b.img,
            stayLabel: 'Keep designing'
          });
          refreshPill();
          if (window.LIOrder) window.LIOrder.updateBadge();
        })
        .catch(function (err) {
          adding = false;
          console.error('Lucky Builder cart add failed', err);
          window.LIShowCartPopup && window.LIShowCartPopup({
            error: true,
            title: 'Your design is saved',
            sub: 'It could not be added to your order: ' + ((err && err.message) || 'cart error') + '. Please try again.'
          });
        });
    });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-lucky-builder]');
    for (var i = 0; i < wraps.length; i++) boot(wraps[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();